/** @format */
import { logger } from '@toucan/client/global/application';

export const resetIntercomSession = () => {
    try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access -- Legacy code: do not use as an example.
        (window as any)?.Intercom?.('shutdown');
        document.cookie.split(';').forEach((cookie) => {
            const cookieName = cookie.split('=')[0].trim();
            if (cookieName.startsWith('intercom-')) {
                document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
            }
        });
    } catch (error: unknown) {
        const errorMessage = (error as Error | string).toString();
        logger.error(`Could not reset Intercom: ${errorMessage}`);
    }
};
